import React, { Component } from 'react';
import { Radio } from 'semantic-ui-react';

import HttpUtils from '../../utils/http';
import ReviewDomItem from  "./reviewDomItem";
import Slider from 'react-slick';
import Responsive from 'react-responsive';

export default class reviewProduct extends Component {
	constructor(props) {
		super(props);

		this.next = this.next.bind(this);
		this.previous = this.previous.bind(this);
		this.handleInputChange = this.handleInputChange.bind(this);
		this.state = {
			rating: 1,
			feedback: {},
			reviewPhraseData:[],
			shareAge: false,
			shareEthnicity: false,
			isfeedbackSettings:false,  // 用户是否保存过一次Share your。第一次提交feedbackSettings 用 POST ，以后就用PUT
			feedbackSettingsId: '',
		};
	}

	componentDidMount(){
		// 获取客户是否分享自己的年龄和种族
		HttpUtils.get("/api/product-feedback-settings?user-id="+localStorage.getItem("user_id")).then(response =>{
			this.setState({
				shareAge:response.shareAge,
				shareEthnicity:response.shareEthnicity,
				isfeedbackSettings:true,
				feedbackSettingsId: response.id
			})
		}).catch((err)=>{
			this.setState({
				isfeedbackSettings: false
			})
		})
	}

	next() {
		this.slider.slickNext();
	}

	previous() {
		this.slider.slickPrev();
	}



	handleCreateReviewDom() {
		const productJsonData = this.props.product;
		const reviewDom = productJsonData.map((product, index) => {
			return (
				<ReviewDomItem product={product} feedbackSettingsId={this.state.feedbackSettingsId} nextProduct={this.next} dataLength={productJsonData.length} index={index} shareAge={this.state.shareAge} shareEthnicity={this.state.shareEthnicity} isfeedbackSettings={this.state.isfeedbackSettings} closeReviewModal={this.props.closeReviewModal}></ReviewDomItem>
			)
		})
		return reviewDom;
	}

	handleInputChange(name){
    this.setState({
      [name]: !this.state[name]
    });
	}

	render() {
		const sliderSettings = {
			dots: false,
			infinite: false,
			speed: 250,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows:false,
			draggable:false,
			appendDots: () => (
			  <div></div>
			)
		  };
		return (
			<div className="product-review-zone-1">
					<div className="product-review-zone">
					<div className="product-top-bg"></div>
					<Slider ref={c => (this.slider = c)} { ...sliderSettings } >
						{this.handleCreateReviewDom()}
					</Slider>
					<Responsive maxWidth={ 767 }>
						<div className="solid-division"></div>
						<div className="share-your-zone mobile">
							<div className="share-your-title">Share your…</div>
							<div className="share-your-radio">
								<Radio className="share-1 readOnly-share-item" toggle readOnly checked={true} label="Skin type & skin concerns"></Radio>
								<Radio toggle label="Age" className="no-readonly" name="shareAge" onChange={()=>{this.handleInputChange('shareAge')}} checked={this.state.shareAge}></Radio>
								<Radio className="share-1 readOnly-share-item" toggle readOnly checked={true} label="Name"></Radio>
								<Radio className="no-readonly" toggle label="Ethnicity" name="shareEthnicity" onChange={()=>{this.handleInputChange('shareEthnicity')}} checked={this.state.shareEthnicity}></Radio>
							</div>
						</div>
				</Responsive>
				</div>
				<Responsive minWidth={ 767 }>
					<div className="share-your-zone pc-share-your-zone">
							<div className="share-your-title">Share your…</div>
							<div className="share-your-radio">
								<Radio className="share-1 readOnly-share-item" toggle readOnly checked={true} label="Skin type & skin concerns"></Radio>
								<Radio className="share-1 readOnly-share-item" toggle readOnly checked={true} label="Name"></Radio>
								<Radio className="share-1" toggle label="Age" name="shareAge" onChange={()=>{this.handleInputChange('shareAge')}} checked={this.state.shareAge}></Radio>
								<Radio className="share-1 no-readonly" toggle label="Ethnicity" name="shareEthnicity" onChange={()=>{this.handleInputChange('shareEthnicity')}} checked={this.state.shareEthnicity}></Radio>
							</div>
					</div>
				</Responsive>	
			</div>
			
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/review/reviewProduct.js